import React, { useCallback, useEffect, useState } from 'react';
import { format, startOfMonth } from 'date-fns';
import { Controller } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import Datepicker from 'components/Inputs/DatePicker';
import FlexSelect from 'components/Inputs/FlexSelect';
import { toast } from 'react-toastify';
import priceCatalogService from 'views/CRM/PriceCatalog/service/priceCatalogService';

const dateRules = {
  required: 'Data é obrigatória',
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};
const getDateBegin = () => {
  const date = new Date();
  const firstDayMonth = new Date(
    date.getFullYear('pt-br'),
    date.getMonth('pt-br'),
    1
  );
  return format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
};
const toISOFormat = (dateTimeString) => {
  const [date] = dateTimeString.split(' ');
  const [DD, MM, YYYY] = date.split('/');
  return `${DD}/${MM}/${YYYY}`;
};

const DefaultFieldsFilterForm = ({
  control,
  setValue,
  getValues,
  register
}) => {
  const [priceCatalogs, setPriceCatalogs] = useState([]);

  const getCatalogs = useCallback(() => {
    priceCatalogService
      .getAllPriceCatalogs()
      .then((response) => {
        setPriceCatalogs(response.data.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao buscar os catálogos de preço');
      });
  }, []);

  useEffect(() => {
    getCatalogs();
  }, [getCatalogs]);

  return (
    <>
      <Row className="mb-3">
        <Col sm="4">
          <label className="form-control-label">Data inicial</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateBegin"
                valueController={setValue}
                defaultValue={props.value}
              />
            )}
            control={control}
            name="dateBegin"
            rules={dateRules}
            defaultValue={getDateBegin()}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Data final</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateEnd"
                valueController={setValue}
                defaultValue={props.value}
              />
            )}
            control={control}
            name="dateEnd"
            defaultValue={new Date().toLocaleDateString('pt-br')}
            rules={{
              ...dateRules,
              validate: async (value) => {
                if (
                  new Date(toISOFormat(value)) <
                  new Date(toISOFormat(getValues()['dateBegin']))
                ) {
                  return 'A data final não pode ser anterior à inicial!';
                } else {
                  return true;
                }
              }
            }}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Catálogos de Preço</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={priceCatalogs || []}
                isMulti={false}
                value={props.value}
                valueController={setValue}
                fieldName="catalogId"
                labelName="name"
                valueName="id"
                isClearable={true}
                closeMenuOnSelect={true}
              />
            )}
            control={control}
            rules={{
              required: 'Catálogo de preço é obrigatório'
            }}
            defaultValue=""
            name="catalogId"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="12">
          <label
            className="form-control-label"
            style={{ marginRight: '20px', fontWeight: '400' }}
          >
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="creation"
              defaultChecked={true}
            />{' '}
            Data de criação
          </label>
          <label className="form-control-label" style={{ fontWeight: '400' }}>
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="last_update"
              defaultChecked={false}
            />{' '}
            Data de última alteração
          </label>
        </Col>
      </Row>
    </>
  );
};

export default DefaultFieldsFilterForm;
